export { default as reducer } from './favorite.ducks';



// WEBPACK FOOTER //
// ./src/routes/Favorite/index.ts